// Map Firebase error codes → thông báo tiếng Việt thân thiện
export const getAuthErrorMessage = (error) => {
  if (!error) return null;
  
  const code = error.code;
  const message = error.message || '';

  const errorMap = {
    'auth/invalid-credential': 'Sai email hoặc mật khẩu. Vui lòng kiểm tra lại.',
    'auth/user-not-found': 'Tài khoản không tồn tại. Vui lòng kiểm tra lại email.',
    'auth/wrong-password': 'Mật khẩu không đúng. Vui lòng thử lại.',
    'auth/invalid-email': 'Email không hợp lệ.',
    'auth/user-disabled': 'Tài khoản này đã bị vô hiệu hóa.',
    'auth/too-many-requests': 'Bạn đã thử quá nhiều lần. Vui lòng đợi vài phút rồi thử lại.',
    'auth/email-already-in-use': 'Email này đã được sử dụng.',
    'auth/weak-password': 'Mật khẩu quá yếu (cần ít nhất 6 ký tự).',
    'auth/network-request-failed': 'Lỗi kết nối mạng. Vui lòng kiểm tra Internet.',
    'auth/popup-closed-by-user': 'Bạn đã đóng cửa sổ đăng nhập.',
    'auth/requires-recent-login': 'Vui lòng đăng nhập lại để thực hiện thao tác này.',
  };

  return errorMap[code] || `Lỗi: ${message}`;
};